module.exports = __webpack_public_path__ + "static/img/bg-Ashare-icon.d3efabc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/bg-Ashare-icon.png
// module id = 1548
// module chunks = 0